export default "__VITE_ASSET__DPnz_pGM__"